/* @flow */
import React from 'react';

import Text from 'components/Text.jsx';
import Button from 'components/Button.jsx';
import CurrentUser from 'auth/CurrentUser';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import Glyph from 'components/Glyph.jsx';
import HeartShare from 'components/HeartShare.jsx';
import Hovercard from 'components/Hovercard.jsx';
import HovercardBody from 'components/HovercardBody.jsx';
import LayerTrigger from 'components/LayerTrigger.jsx';
import Link from 'components/Link.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import UserNavigationMenu from 'components/UserNavigationMenu.jsx';
import RecentView from 'chat/components/RecentView.jsx';
import SupportDialog from 'support/components/SupportDialog.jsx';
import ZopimLink from 'support/components/ZopimLink.jsx';
import ZopimChevronBox from 'support/components/ZopimChevronBox.jsx';
import AdminConsoleAccess from 'admin/components/AdminConsoleAccess.jsx';

import styles from './styles/AppTopBar.css';

type Props = {
  showRCE?: boolean,
  showZopim?: boolean,
  userName: string,
  unreadCount: number,
  displayUnreadIcon?: boolean,
  showingRecent?: boolean,
  showRecent: Function,
  hideRecent: Function,
};

const NOTIFICATION_VISIBILITY_TIME = 6000;

class AppTopBar extends React.Component {
  props: Props;

  componentWillMount() {
    if (this.props.unreadCount > 0) {
      this.showUnreadNotification = true;
    }
  }

  componentWillReceiveProps(nextProps: Object) {
    if (this.props.unreadCount < nextProps.unreadCount) {
      this.showUnreadNotification = true;
    }
  }

  componentDidUpdate() {
    if (this.props.showingRecent) {
      this.showRecentView();
    } else {
      this.hideRecentView();
    }
  }

  showUnreadNotification: boolean = false;

  hideRecentView = () => {
    this.props.hideRecent();
    if (this.refs.recentView) {
      this.refs.recentView.hideLayer();
    }
  };

  showRecentView = () => {
    this.props.showRecent();
    if (this.refs.recentView) {
      this.refs.recentView.showLayer();
    }
  };

  renderUnreadIcon(unreadCount: number) {
    const classBadgingEnabled = CurrentUser.inExpVariant('CLASS_BADGES');

    const trigger = (
      <Link data-test-selector="recent-view-unread-icon" onClick={this.showRecentView}>
        <Glyph name="clock" className={styles.unreadGlyph} solo />
        {
          unreadCount > 0 &&
          !classBadgingEnabled &&
          <div className={styles.unreadCountContainer}>
            <span data-test-selector="unread-count" className={styles.unreadCount}>{unreadCount}</span>
          </div>
        }
      </Link>
    );

    if (classBadgingEnabled) {
      return trigger;
    }

    const notification = (
      <Hovercard
        className={styles.unreadNotification}
        hideOnEscape={false}
        hideOnBlur={false}>
        <CSSTransitionGroup
          transitionAppear
          transitionEnterTimeout={1000}
          transitionAppearTimeout={1000}
          transitionLeaveTimeout={1000}
          transitionName={styles}>
          <HovercardBody onClick={this.showRecentView} className={styles.unreadNotificationBody}>
            {`${unreadCount} unread message${unreadCount === 1 ? '' : 's'}`}
          </HovercardBody>
        </CSSTransitionGroup>
      </Hovercard>
    );

    return (
      <LayerTrigger
        ref={(layer) => {
          if (layer && this.showUnreadNotification && unreadCount > 0) {
            setTimeout(layer.showLayer, 0);
            setTimeout(layer.hideLayer, NOTIFICATION_VISIBILITY_TIME);
            this.showUnreadNotification = false;
          }
        }}
        layer={notification}
        trigger="manual"
        alignment="right"
        placement="bottom">
        {trigger}
      </LayerTrigger>
    );
  }

  renderUnreadIndicator() {
    const { unreadCount } = this.props;

    return (
      <div className={styles.unreadIndicator} >
        <LayerTrigger
          data-test-selector="recent-view-trigger"
          ref="recentView"
          layer={<RecentView hide={this.hideRecentView} />}
          trigger="manual">
          {
            this.props.showingRecent ? <div /> : this.renderUnreadIcon(unreadCount)
          }
        </LayerTrigger>
      </div>
    );
  }

  render() {
    return (
      <div className={styles.this}>
        <div className={styles.left}>
          <UserNavigationMenu showSettings showGetTheApp showLogout showRCE={this.props.showRCE}>
            <Link color="inherit" className={styles.userLink}>
              <Text truncate size="medium">{this.props.userName}</Text>
              <Glyph name="chevron-down" size="xxsmall" />
            </Link>
          </UserNavigationMenu>
          {this.props.displayUnreadIcon && this.renderUnreadIndicator()}
        </div>
        <div className={styles.actions}>
          <AdminConsoleAccess>
            <Link className={styles.adminConsoleLink} to="/admin" color="inherit" target="_blank">
              <Button size="xxsmall" level="secondary" color="pitch">
                Go to Admin Console
              </Button>
            </Link>
          </AdminConsoleAccess>
          {this.props.showZopim &&
            <ZopimLink>
              <ZopimChevronBox />
            </ZopimLink>
          }
          <ModalTrigger data-test-selector="support-dialog-trigger" modal={<SupportDialog />}>
            <Link eventElementName="Navigation-help" color="pitch">
              <Glyph className={styles.help} name="help" size="large" solo />
            </Link>
          </ModalTrigger>
          <HeartShare className={styles.share} color="pitch" size="large" />
        </div>
      </div>
    );
  }
}


export default AppTopBar;



// WEBPACK FOOTER //
// ./src/app/components/AppTopBar.jsx